<header [ngClass]="environment" class="d-flex align-items-center">
    <div class="w-100">
        <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center w-100">
                <img *ngIf="hasLogo" src="assets/images/actiris-logo-element.svg" alt="Logo Actiris.brussels" class="mr-200" />
                <button (click)="goToActiris()" act-ds-button color="link" icon="keyboard_arrow_left" iconSide="left" type="button">
                    {{ 'COMMON.BACK_TO_ACTIRIS' | translate }}
                </button>
            </div>

            <ng-content></ng-content>
            <div *ngIf="!isLoggedIn()" class="d-flex w-100 justify-content-between">
                <span class="d-lg-flex">{{ 'COMMON.MY_ACTIRIS' | translate }}</span>
            </div>

            <div *actDesktop class="desktop-menu d-flex justify-content-end align-items-center flex-1">
                <div *ngIf="isLoggedIn()" class="position-relative font-size-0875" id="menu" [appMenuTriggerFor]="menu">
                    <div class="username d-flex align-items-center border-right pr-100 mr-100">
                        <span class="font-weight-bold">{{ username() }}</span>
                        <div class="act-icon act-icon-caret-down pl-50"></div>
                    </div>
                    <div #menu class="d-none">
                        <ng-container *ngTemplateOutlet="subMenu"></ng-container>
                    </div>
                </div>
            </div>
            <act-language-selection
                [currentLanguage]="currentLanguage"
                [languages]="languages"
                (changeLanguage)="changeLanguage($event)"
            ></act-language-selection>
            <div *actMobile class="mobile-menu d-flex justify-content-end align-items-center flex-1">
                <div
                    class="act-icon act-icon-burger-menu d-flex justify-content-end align-items-center fs-250"
                    (click)="isPaneHidden = false"
                    *ngIf="isLoggedIn() || !isLoginPage"
                ></div>
                <div class="act-burger-pane d-block" [ngClass]="{ shown: !isPaneHidden }">
                    <button class="act-close p-0 act-fg-white mb-100" (click)="isPaneHidden = true">
                        <i class="act-icon act-icon-close"></i>
                    </button>
                    <ng-container *ngTemplateOutlet="subMenu"></ng-container>
                </div>
            </div>
        </div>
    </div>
</header>

<ng-template #subMenu>
    <div class="sub-menu px-100 font-size-0875 font-weight-regular">
        <div *actMobile class="d-flex align-items-center justify-content-between border-bottom-line py-100">
            <act-language-selection
                [currentLanguage]="currentLanguage"
                [languages]="languages"
                (changeLanguage)="changeLanguage($event)"
                class="m-auto"
            ></act-language-selection>
        </div>
        <div class="py-75" *ngIf="isLoggedIn()">
            <ul>
                <li class="my-25" *ngIf="'canViewProfile' | permission">
                    <a [routerLink]="['/profile']" class="act-link">
                        {{ 'SHARED.HEADER.PROFILE' | translate }}
                    </a>
                </li>
                <li class="my-25">
                    <button type="button" class="act-link" (click)="logout()">
                        {{ 'SHARED.HEADER.LOGOUT' | translate }}
                    </button>
                </li>
            </ul>
        </div>
        <div class="py-75" *ngIf="!isLoggedIn() && !isLoginPage">
            <ul>
                <li class="my-25">
                    <a
                        [routerLink]="['login']"
                        [queryParamsHandling]="'preserve'"
                        class="d-block p-0 font-size-0875 m-auto text-center"
                        (click)="isPaneHidden = false"
                    >
                        {{ 'COMMON.LOGIN' | translate }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</ng-template>
